jQuery(document).foundation();

// Shipping banner in header

jQuery(document).ready(function($){
    "use strict";

    function top_bar() {
         // console.log($(document).scrollTop());
        if ($(document).scrollTop() >= 64) {


            $('div.header_banner').css('height', '0');
            $('#header.header-v1').css('height', '70px');

        }
        else {
            $('div.header_banner').css('height', '64px');
            $('#header.header-v1').css('height', '130');
        }
    }



    /* Sticky Header */
    if (/Android|BlackBerry|iPhone|iPad|iPod|webOS/i.test(navigator.userAgent) === false) {


        $(document).scroll(function() { top_bar(); });
        top_bar();


    }



});
